<script>

export default {
    name: 'dt-lang',
    data() {
        return {
            isOver: false,
            isClicked: false,
        }
    },
    methods: {
        toggleLang(mod=undefined) {
            if(mod=='over') {
                if(this.isOver)
                    return
                else
                    this.isOver = true
            }
            if(mod=='leave') {
                this.isOver = false
                if(this.isClicked) {
                    this.isClicked = false
                    return
                }
            }
            if(mod=='click') {
                this.isClicked = true
                if(this.isOver)
                    return
            }
            this.ST._set('lang', this.isENG ? 'ru' : 'en')
            try{
                this.ST._save()
            }
            catch(err) {
                this.CS.err(
                    `Can't save settings`, this.CLASS, 'toggleLang', err)
            }
        },
    }
}
</script>

<template lang="pug">

div.dt-lang
    div.dt-lang__label(
        :class="{'dt-lang__label_curr': isRUS}") RUS
    dkbr-button-dial.dt-lang__button(
        posx="center"
        posy="top"
        dir="bottom"
        icon="language"
        :iconSize="2"
        :isHover="true"
        @click.native="toggleLang('click')"
        @mouseover.native="toggleLang('over')"
        @mouseleave.native="toggleLang('leave')")
    div.dt-lang__label(
        :class="{'dt-lang__label_curr': isENG}") ENG
</template>

<style lang="sass">

@import '~@dt/sass/root.sass'

.dt-lang
    position: relative
    +flex(column, nowrap, space-between, center)
    &__label
        +color-font(light)
        +font(base-bold-small)
        &_curr
            +color-font(light3)
            +font(base-bold)
</style>



// WEBPACK FOOTER //
// site/deeptensor/components/Lang.vue